export const PRODUCT_OBJ = {
    us: [
        [
            // 第一个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '7414779576393',
                variantId: '42093673021513',
                // tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '7414779576393',
                variantId: '42093673021513',
                // tag: 'EARLY BIRD',
            },
        ],
        [
            // 第二个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '7414779576393',
                variantId: '54335533842505',
                // tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '7414779576393',
                variantId: '54335533842505',
                // tag: 'EARLY BIRD',
            },
        ],
        [
            // 第三个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '7414779576393',
                variantId: '54441886318665',
                // tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '7414779576393',
                variantId: '54441886318665',
                // tag: 'EARLY BIRD',
            },
        ],
        [
            // 第四个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '7414779576393',
                variantId: '54335533908041',
                // tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '7414779576393',
                variantId: '54335533908041',
                // tag: 'EARLY BIRD',
            },
        ],
        [
            // 第五个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '7414779576393',
                variantId: '54335533940809',
                tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '7414779576393',
                variantId: '54335533940809',
                // tag: 'EARLY BIRD',
            },
        ],
        [
            // 第六个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '7414779576393',
                variantId: '54335533973577',
                // tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '7414779576393',
                variantId: '54335533973577',
                // tag: 'EARLY BIRD',
            },
        ],
    ],
    ca: [
        [
            // 第一个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '15052470157683',
                variantId: '52405151662451',
                tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '15052470157683',
                variantId: '52405151662451',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第二个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '15052470157683',
                variantId: '52405151564147',
                tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '15052470157683',
                variantId: '52405151564147',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第三个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '15052470157683',
                variantId: '52405151596915',
                tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '15052470157683',
                variantId: '52405151596915',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第四个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '15052470157683',
                variantId: '52405151629683',
                tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '15052470157683',
                variantId: '52405151629683',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第五个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '15052470157683',
                variantId: '52466024153459',
                tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '15052470157683',
                variantId: '52466024153459',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第六个产品组 超早鸟 => 早鸟 => 常规（此处无）
            {
                productId: '15052470157683',
                variantId: '52466024186227',
                tag: 'SUPER EARLY BIRD',
                type: 'countdown', // 早鸟类型 'countdown' | 'inventory' 倒计时：倒计时结束则进入下一阶段 库存：库存不足则进入下一阶段
                countdown: '2025/04/28 15:00:00',
            },
            {
                productId: '15052470157683',
                variantId: '52466024186227',
                tag: 'EARLY BIRD',
            },
        ],
    ],
    uk: [],
    eu: [],
    de: [],
    fr: [],
    it: [],
    es: [],
    jp: [],
};
